module.exports = __webpack_public_path__ + "static/joinUs-0f7aa37087ae9f1d7072a860d3a54dad.svg";